import { DataSourceType as e, DataTargetType as a } from "@decentriq/graphql/dist/enums";
var t = /* @__PURE__ */ ((o) => (o.Table = "Table", o.Unstructured = "Unstructured", o))(t || {}), r = /* @__PURE__ */ ((o) => (o[o.EXPORT = 0] = "EXPORT", o[o.IMPORT = 1] = "IMPORT", o))(r || {});
const s = {
  Table: "Upload as a table",
  Unstructured: "Upload as a file"
}, u = {
  [e.S3]: "Amazon S3",
  [e.Snowflake]: "Snowflake",
  [e.Local]: "Computer",
  [e.Compute]: "Computation",
  [e.ComputeV2]: "Computation",
  [e.Salesforce]: "Salesforce",
  [e.Azure]: "Azure Blob Storage",
  [e.GoogleCloudStorage]: "Google Cloud Storage",
  [e.Permutive]: "Permutive",
  [e.Databricks]: "Databricks"
}, d = {
  [a.S3]: "Amazon S3",
  [a.Meta]: "Meta Ads",
  [a.GoogleDv_360]: "Google DV 360",
  [a.GoogleCloudStorage]: "Google Cloud Storage",
  [a.TradeDesk]: "The Trade Desk",
  [a.Azure]: "Azure Blob Storage",
  [a.Permutive]: "Permutive",
  [a.Adform]: "Adform",
  [a.GoogleAdManager]: "Google Ad Manager",
  [a.Sportradar]: "Sportradar ad:s DSP",
  [a.MicrosoftDsp]: "Microsoft Invest DSP",
  [a.Splicky]: "Splicky",
  [a.GoogleAds]: "Google Ads",
  [a.Tiktok]: "Tiktok",
  [a.Snapchat]: "Snapchat"
};
export {
  t as L,
  r as S,
  d as a,
  u as d,
  s as l
};
//# sourceMappingURL=index.B-E4PB3F.js.map
